import { ViewNotFound } from '@view/view_not_found/view_not_found_route.component';
import { useResolve } from '@visiba/instantiation';
import { usePresentation } from '@visiba/presentation';
import { useParams } from 'react-router';
import { InfoViewAppointment } from './_info_view_appointment/info_view_appointment.component';
import { PresentationModel, VisitsController } from './view_patient_cases.controller';

export function SelectedAppointmentCase() {
	const params = useParams<'callticket'>();
	const controller = useResolve(VisitsController);
	const presentation = usePresentation(controller.presentation);
	const c = params.callticket != null ? getAppointmentCase(presentation, params.callticket) : null;

	if (c == null) return <ViewNotFound />;

	return <InfoViewAppointment model={c} />;
}

function getAppointmentCase(presentation: Readonly<PresentationModel>, id: string) {
	if (presentation.completedCases == null || presentation.ongoingCases == null) return null;

	const cases = [...presentation.completedCases.appointmentCases, ...presentation.ongoingCases.appointmentCases];
	const c = cases.find((c) => c.getIdentifier() === id);

	return c ?? null;
}
